import React from 'react';
import { Create, SimpleForm } from 'react-admin';
import Permission from '../../components/Permission';
import RequiredChain from '../../components/RequiredChain';
import { PERMISSIONS } from '../../constants';
import WhatsappNumberForm from './WhatsappNumberForm';
import ConfirmSaveToolbar from './ConfirmSaveToolbar';

const CreateWhatsappNumber = (props) => (
  <Permission permission={PERMISSIONS.MANAGE_WHATSAPP_NUMBERS}>
    <RequiredChain>
      <Create {...props} title="Cadastrar número de WhatsApp" redirect="list">
        <SimpleForm sx={{ maxWidth: 620 }} toolbar={<ConfirmSaveToolbar />}>
          <WhatsappNumberForm />
        </SimpleForm>
      </Create>
    </RequiredChain>
  </Permission>
);

export default CreateWhatsappNumber;
